import React from 'react';
import {get as _get, get, toLower} from 'lodash';
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {
    addErrorAlert,
} from "../../../store/calls/alertLoadingDispatch";
import api from '../../../store/api'
import validators from "../../../utils/forms/validators";
import formatters from "../../../utils/forms/formatters";
import settings from "../../../settings";
import {userTypeSelect} from "../../../utils/forms/preconfiguredInputs";
import * as actions from "../../../store/actions"
import GoogleLoginButton from "../../subcomponents/auth/GoogleLoginButton";
import LinkedinLoginButton, {
    handleLinkedinLoginRequest,
    LinkedinSignInButton
} from "../../subcomponents/auth/LinkedinLoginButton";

// Local Components
import PublicWrapper from "../../theme/wrappers/PublicWrapper";
import Logo from "../../theme/logo/logo";
import LogoFooter from "../../theme/logoFooter/logo";
import UserCreationForm from "../../subcomponents/auth/UserCreationForm";
import OTPForm from "../../subcomponents/auth/OTPForm";
import {getAndResetLoginPath, openTabsOnCompletion} from "../../../utils/session/authFlow";
import { updateUser } from '../../../store/calls';
import { getSubdomain } from '../../../utils/general';



class CreateUserScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            created_user: null,
            email_resent: false,
            selected_method: null,
            referred_by: null
        }
        this.linkedinRedirectionURI = window.location.hostname === 'localhost' ? 'http://localhost:3000/create-account' : 'https://cleanfi.com/create-account';


        this.createUserInputs = [
            {
                type: "text",
                dataKey: "name",
                label: "Your Name",
                inputClasses: "is-medium",
                ...validators.isStringOfMinLength(2),
            },
            {
                type: "phone",
                dataKey: "cell_phone",
                label: "Cell Phone",
                inputClasses: "is-medium",
                placeholder: "(XXX) XXX-XXXX",
                formatter: formatters.phone.formatter,
                ...validators.isPhoneNumber,
            },
            {
                type: "text",
                dataKey: "email",
                label: "Email",
                inputClasses: "is-medium",
                ...validators.isEmail,
            },
            {
                dataKey: "role",
                label: "Select the option that best describes your role",
                inputClasses: "is-medium is-fullwidth",
                ...userTypeSelect,
                ...validators.exists
            },
            {
                type: "text",
                dataKey: "company",
                label: "Company",
                inputClasses: "is-medium",
            },
            {
                type: "password",
                dataKey: "password",
                label: "Password",
                inputClasses: "is-medium",
                ...validators.isStringOfMinLength(4)
            }
        ]
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const selected_method = (params.get('method') + '').toLowerCase()
        if (['email'].includes(selected_method)) {
            this.setState({ selected_method })
        }
        if (params.get('ref')) {
            this.setState({ referred_by: params.get('ref') })
            setTimeout(() => console.log("NOTES REFERRAL CODE", this.state.referred_by, params.get('ref')), 500)
        }
    }



    requestNewConfirmationLink = () => {
        api.get('resend-otp', {u: 139, p:  this.props.focusedProject}) // this.state.created_user.id})
            .catch(() => {
                addErrorAlert("It seems there was a problem resending that message.")
            })
            .then(() => {
                this.setState({email_resent: true},
                    () => setTimeout(() => this.setState({email_resent: false}), 2500)
                )
            })
    }

    onComplete = async () => {
        console.log("ON COMPLETE")
        console.log("user data", this.props.userData)

        let subdomain = getSubdomain();
        let {referred_by} = this.state;
        console.log("refferal code", referred_by)
        if (referred_by || subdomain) {
            updateUser({referred_by, affiliate_source: subdomain})
        }
         
        openTabsOnCompletion();
        this.props.history.push(getAndResetLoginPath());
    }

    render() {
        return (
            <PublicWrapper
                showNav={false}
                cornerCoverStyle={{zIndex: 2}}
            >
                <section className="hero is-fullheight" id="create-user-hero">
                    <div className="hero-body" style={{zIndex: 2}}>
                        <div className="container"
                             style={{maxWidth: '500px'}}
                        >

                            <div className="box hero-form-card y-overflow">
                                <Logo className="p-0"/>


                                {!this.state.selected_method &&
                                    <>
                                        <div className="is-flex is-justify-content-center"
                                             style={{marginTop: '-1em'}}>
                                            <div className="has-text-weight-semibold has-text-primary has-text-centered">Create your account and start getting financing options for your commercial properties</div>
                                        </div>

                                        <div className="is-flex is-justify-content-center my-3 mt-5 is-fullwidth">
                                            <GoogleLoginButton
                                                successCallback={this.onComplete}
                                                failureCallback={() => addErrorAlert("There was a problem. We were unable to create your account.")}
                                            />
                                        </div>
                                        <div className="is-flex is-justify-content-center my-3 is-fullwidth">
                                            <LinkedinSignInButton
                                                prompt="Sign up with LinkedIn"
                                                redirectionURI={this.linkedinRedirectionURI}
                                                successCallback={this.onComplete}
                                                failureCallback={() => addErrorAlert("There was a problem. We were unable to create your account.")}
                                                className="is-fullwidth"
                                            />
                                        </div>
                                        <div className="is-flex is-justify-content-center my-3">
                                            <button className="button is-fullwidth"
                                                 onClick={() => this.setState({selected_method: 'email'})}>Use an Email Address
                                            </button>
                                        </div>
                                        <div className="is-flex is-justify-content-center my-3 ">
                                            <Link to="/login" className="is-fullwidth">
                                                <div className="has-text-centered is-clickable mt-4 has-text-grey is-fullwidth is-size-7">Already have a CleanFi
                                                    account? Login Here.
                                                </div>
                                            </Link>
                                        </div>
                                    </>
                                }



                                {this.state.selected_method === 'email' && !this.state.created_user &&
                                    <>
                                        <div className="is-flex is-justify-content-center"
                                             style={{marginTop: '-1em'}}>
                                            <div className="has-text-weight-semibold has-text-primary has-text-centered">Create your account and start getting financing options for your commercial properties</div>
                                        </div>
                                        <UserCreationForm
                                            onCreate={(user) => {
                                                this.setState({
                                                    created_user: user
                                                })
                                            }}
                                        />
                                        <LogoFooter/>
                                    </>
                                }
                                {this.state.created_user &&
                                    <OTPForm
                                           email={this.state.created_user.email}
                                           onSuccess={this.onComplete}
                                       />
                                }
                            </div>

                        </div>
                    </div>
                </section>
            </PublicWrapper>
        )
    }
}


const mapStateToProps = (state) => ({
    loading: state.user.loading,
    error: state.user.error,
    focusedProject: state.projectLeads.focusedProject,
    formFlow: state.formFlow,
    onLoginPath: state.session.vars?.onLoginPath || '/my-projects',
    userData: state.user.decodedTokenData,
})

const mapDispatchToProps = (dispatch) => ({
    updateTokenData: data => dispatch(actions.user.updateTokenData(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateUserScreen)



